export const hypertee = {
  msrp: 29.99,
  variants: [['SHORT SLEEVE', 'LONG SLEEVE']],
  infoLink: 'https://www.teamtriton.com/hypertee.html',
  items: [
    {
      number: 'HT099',
      hasModel: false,
    },
    {
      number: 'HT100',
      hasModel: false,
    },
    {
      number: 'HT101',
      hasModel: false,
    },
    {
      number: 'HT102',
      hasModel: false,
    },
    {
      number: 'HT103',
      hasModel: false,
    },
    {
      number: 'HT104',
      hasModel: false,
    },
    {
      number: 'HT105',
      hasModel: false,
    },
    {
      number: 'HT106',
      hasModel: false,
    },
    {
      number: 'HT107',
      hasModel: false,
    },
    {
      number: 'HT108',
      hasModel: false,
    },
    {
      number: 'HT109',
      hasModel: false,
    },
    {
      number: 'HT110',
      hasModel: false,
    },
    {
      number: 'HT111',
      hasModel: false,
    },
    {
      number: 'HT112',
      hasModel: false,
    },
  ],
};
